module.exports = __webpack_public_path__ + "static/statistics-in-plain-english-847cc200b7f80f5623ba6c9c709ee363.jpg";